import React from 'react';
import PropTypes from 'prop-types';
import { Image, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Lottie from 'lottie-react';
import BootDrop from '../../assets/lottie/Boot-Drop.json';
import {
  OffsetFeaturePromoComponent,
  InnerWrapper,
  IntroBlock,
  ImageWrap,
  ScrollTextContainer,
  LeftImage,
  RightImage,
  LottieWrapper,
} from './OffsetFeaturePromo.styles';

import Button from '../shared/Button/Button.jsx';
import ScrollingText from '../../components/shared/ScrollingText/ScrollingText.jsx';

const IntroBlockComponent = ({ titleImage, headlineText, supportingContent, cta, backgroundColor, ctaStyle, postcontenttext, showLottie }) => (
    <IntroBlock>
      {showLottie && showLottie === 'boot-drop' && (
        <LottieWrapper>
          <Lottie
            animationData={BootDrop}
            loop
            autoplay
            aria-label="Boot flame animation"
            style={{ width: '100%', height: '100%' }}
          />
        </LottieWrapper>
      )}
      {titleImage?.value?.src && (
          <>
            <Image field={titleImage} className="title-image" imageParams={{ mw: 200 }} />
            <hr />
          </>
      )}
      {headlineText?.value && (
          <h2
              dangerouslySetInnerHTML={{
                __html: headlineText.value.replace(/(®|&reg;|&#174;|&trade;|™|&#8482;)/g, '<sup>$1</sup>')
              }}
          />
      )}
      {supportingContent?.value && (
          <p
              dangerouslySetInnerHTML={{
                __html: supportingContent.value.replace(/(®|&reg;|&#174;|&trade;|™|&#8482;)/g, '<sup>$1</sup>')
              }}
          />
      )}
      {cta?.value?.href && (
          <Button
              text={cta?.value?.text}
              href={cta?.value?.href}
              path={cta?.value?.url}
              target={cta?.value?.target}
              variant={ctaStyle || backgroundColor}
              {...(backgroundColor === 'tan' ? {} : { invertColor: true })}
              type="default"
              {...cta?.value}
          />
      )}
      {postcontenttext && (
          <p
              className="post-text-content"
              dangerouslySetInnerHTML={{
                __html: postcontenttext,
              }}
          />
      )}
    </IntroBlock>
);

const OffsetFeaturePromo = ({ fields = {}, params = {}, sitecoreContext }) => {
  const {
    cta = {},
    foregroundImageLeft = {},
    foregroundImageRight = {},
    headlineText = {},
    scrollingVanityTextElements = [],
    supportingContent = {},
    titleImage = {},
    bottomBorderImage
  } = fields;
  const { trademarkReplacements = [] } = sitecoreContext;
  const {
    backgroundColor = 'yellow',
    id = null,
    componentclass = null,
    postcontenttext = null,
    ctaStyle = 'red',
    showLottie = '',
  } = params;

  const introBlockProps = {
    titleImage,
    headlineText,
    supportingContent,
    cta,
    backgroundColor,
    postcontenttext,
    ctaStyle,
    showLottie
  };

  return (
    <OffsetFeaturePromoComponent  id={id} className={componentclass} backgroundColor={backgroundColor}>
      <InnerWrapper>
        <IntroBlockComponent {...introBlockProps} />
        <ImageWrap>
          {foregroundImageLeft?.value?.src && (
            <LeftImage>
              <Image
                  field={foregroundImageLeft}
                  srcSet={[{ mw: 800, mh: 800 }]}
                  sizes="800px"
              />
            </LeftImage>
          )}
          <IntroBlockComponent {...introBlockProps} />
          {foregroundImageRight?.value?.src && (
            <RightImage>
              <Image
                  field={foregroundImageRight}
                  srcSet={[{ mw: 800, mh: 800 }]}
                  sizes="800px"
              />
            </RightImage>
          )}
        </ImageWrap>
      </InnerWrapper>
      {bottomBorderImage?.value?.src && (
      <img alt={bottomBorderImage?.value?.alt} src={bottomBorderImage?.value?.src} className="bottom-border-image" />
      )}
      {Array.isArray(scrollingVanityTextElements) && scrollingVanityTextElements.length > 0 && (
        <ScrollTextContainer>
          <ScrollingText scrollingVanityTextElements={scrollingVanityTextElements} />
        </ScrollTextContainer>
      )}
    </OffsetFeaturePromoComponent>
  );
};

OffsetFeaturePromo.propTypes = {
  fields: PropTypes.shape({
    cta: PropTypes.object,
    foregroundImageLeft: PropTypes.object,
    foregroundImageRight: PropTypes.object,
    headlineText: PropTypes.object,
    scrollingVanityTextElements: PropTypes.array,
    supportingContent: PropTypes.object,
    titleImage: PropTypes.object,
  }),
};

export default withSitecoreContext()(OffsetFeaturePromo);